import type { ApolloError } from "@apollo/client"
import ErrorMessage from "@/v2-ui/ErrorMessage"
import Dialog from "@/v2-ui/dialog"
import Label from "@/v2-ui/label"
import Checkbox from "@/v2-ui/checkbox"
import Button from "@/v2-backoffice-client/components/button"
import UserCreateManyForm from "@/v2-backoffice-client/user/create/many/UserCreateManyForm"
import type { UserCreateManyFormData } from "@/v2-backoffice-client/user/create/many/UserCreateManyForm"

export type UserCreateManyPhaseFormProps = {
  defaultTenantId?: number
  defaultTenantName?: string
  loading: boolean
  error: ApolloError | undefined
  sendAccountEmailChecked: boolean
  onSendAccountEmailChange(checked: boolean): void
  onSubmit(data: UserCreateManyFormData): void
  onClose(): void
}

function UserCreateManyPhaseForm(props: UserCreateManyPhaseFormProps) {
  const {
    defaultTenantId,
    defaultTenantName,
    loading,
    error,
    sendAccountEmailChecked,
    onSendAccountEmailChange,
    onSubmit,
    onClose,
  } = props

  return (
    <>
      <Dialog.Header>
        <Dialog.Title>Create users</Dialog.Title>
        <Dialog.Description>
          Create new user accounts. You can paste multiple emails to populate
          rows quickly.
        </Dialog.Description>
      </Dialog.Header>

      <ErrorMessage className="my-4 text-center" error={error} />

      <UserCreateManyForm
        id="user-create-many-form"
        defaultTenantId={defaultTenantId}
        defaultTenantName={defaultTenantName}
        onSubmit={(data, e) => {
          e.preventDefault()
          onSubmit(data)
        }}
      />

      <div className="flex items-center justify-between mt-4">
        <Label className="flex items-center gap-2 text-sm cursor-pointer text-muted-foreground">
          <Checkbox
            checked={sendAccountEmailChecked}
            onCheckedChange={(checked) => {
              onSendAccountEmailChange(checked === true)
            }}
          />
          Send account info via email
        </Label>
      </div>

      <Dialog.Footer className="flex justify-end gap-3 mt-6">
        <Button type="button" variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button type="submit" form="user-create-many-form" isLoading={loading}>
          {loading ? "Creating..." : "Create Users"}
        </Button>
      </Dialog.Footer>
    </>
  )
}

export default UserCreateManyPhaseForm
